export default {
	"waitingResponse": "Esperando validación",
	"validated": "Validado",
	"editFiles": "Editar Archivos",
	"viewDoc": "Ver Documento",
	"validate": "Validar",
	"RepSecNotRequired": "¡REPSE validado!",
	"requiresRepSec": "¡Requiere validación de REPSE!",	
	"userRoleDisclaimer":"Si selecciona el rol de Proveedor tiene que agregar un proveedor al usuario",
	"enteruserRoleId": "Introduzca el rol de usuario",
	"msgAfterUpdateStatus": "Estado actualizado con éxito",
	"updateStatusTitle": "Actualizar Estado",
	"updateStatusMessage": "¿Desea actualizar el estado de este registro?",
	"updateStatus": "Actualizar Estado",
	"setRejected": "Rechazar",
	"setApproved": "Aprobar",
	"setPaid": "Pagado",
	"confirm": "Confirmar",
	"enterComment": "Proporcione un comentario",
	"rejectRepseTitle": "Rechazar REPSE", 
	"rejectRepseMessage": "¿Desea rechazar los documentos de Registro de Prestadoras de Servicios Especializados u Obras Especializadas (REPSE) para inhabilitar al proveedor?",
	"msgAfterReject": "Rechazado con éxito",
	"msgAfterAccept": "Aceptado con éxito",
	"acceptRepseTitle": "Validar REPSE",
	"acceptRepseMessage": "¿Desea validar los documentos de Registro de Prestadoras de Servicios Especializados u Obras Especializadas (REPSE) para aprobar al proveedor?",
	"validRepse": "Validar REPSE",
	"rejectRepse": "Rechazar REPSE",
	"UnderReview": "En revisión",
	"Valid": "Verificado",
	"file_path_one": "Declaración del SAT",
	"file_path_two": "Declaración de ISR",
	"file_path_three": "Resumen de liquidaciones ante el IMSS",
	"selectYesOrNo": "Seleccione si o no",
	"checking": "Comprobando...",
	"no": "No",
	"yes": "Si",
	"checkRepse": "¿Requiere REPSE?",
	"Active": "Activo",
	"Inactive": "Inactivo",
	"Definitive": "Definitivo",
	"Distorted": "Desvirtuados",
	"Presumed": "Presuntos",
	"FavorableSentences": "Sentencias favorables",
	"Allinvoices": 'Todas las facturas',
	"Recievedinvoices": 'Facturas recibidas',
	"Pendinginvoices": 'Facturas pendientes',
	"Rejectedinvoices": 'Facturas rechazadas',
	"Approvedinvoices": 'Facturas aprobadas',
	"Paidinvoices": 'Facturas pagadas',
	"invoices": 'Facturas',
	"aboutUs": "Sobre nosotros",
	"accountDetail": "Detalle de cuenta",
	"action": "Acción",
	"addNewEfo": "Agregar EFOS",
	"addNewMail": "Agregar correo de factura",
	"addNewPermission": "Agregar permiso",
	"addNewRepse": "Agregar REPSE",
	"addNewRole": "agregar rol",
	"addNewSupplier": "Agregar proveedor",
	"addNewTabledisplaylabel": "Agregar nuevo",
	"addNewUser": "Agregar usuario",
	"addNewInvoice": "Agregar factura",
	"editInvoice": "Editar factura",
	"invoiceDetails": "Detalles de la factura",
	"User": "Usuario",
	"Admin": "Administrador",
	"Supplier": "Proveedor",
	"administration": "Administración",
	"allRightsReserved": "Todos los derechos reservados",
	"alreadyExist": " ¡Ya existe!\r\n\t\t",
	"alreadyHaveAnAccount": "¿Ya tienes una cuenta?",
	"available": "Disponible",
	"back": "Regresa",
	"browse": "Vistazo",
	"capitalLetter": "Letra mayúscula",
	"changeEmail": "Cambiar e-mail",
	"changePassword": "Cambia la contraseña",
	"charactersMinimum": "caracteres min",
	"checkingAvailability": "Comprobando disponibilidad ...",
	"chooseFilesOrDropFilesHere": "Elija archivos o suelte archivos aquí",
	"clickHereToLogin": "Haga clic aquí para ingresar",
	"close": "Cerrar",
	"confirmNewPassword": "Confirmar nueva contraseña",
	"confirmPassword": "Confirmar contraseña",
	"congratulations": "¡Felicidades!",
	"contactSystemAdmin": "Póngase en contacto con el administrador del sistema para obtener más información",
	"contactUs": "Contáctenos",
	"continue": "Continuar",
	"createdAt": "Creado el",
	"createRecord": "Crear registro",
	"currentPassword": "Contraseña actual",
	"dataImportedSuccessfully": "Datos importados con éxito",
	"delete": "Borrar",
	"deleteAccount": "Borrar cuenta",
	"deleteRecord": "Eliminar el registro",
	"deleteSelected": "Eliminar seleccionado",
	"deleteThisRecord": "Eliminar este registro",
	"dontHaveAnAccount": "¿No tienes una cuenta?",
	"edit": "Editar",
	"editAccount": "Editar cuenta",
	"editEfo": "Editar Efo",
	"editMail": "Editar factura",
	"editMyAccount": "Editar mi cuenta",
	"editPermission": "editar permiso",
	"editRepse": "Editar Repse",
	"editRole": "Editar rol",
	"editSupplier": "Editar provedoor",
	"editTabledisplaylabel": "Editar",
	"editThisRecord": "Editar este registro",
	"editUser": "Edit User",
	"efoDetails": "Efo Details",
	"efosMenu": "EFOS",
	"efos": "Empresas que Facturan Operaciones Simuladas (EFOS)",
	"email": "Correo electrónico",
	"emailAddressChanged": "La dirección de correo electrónico cambió con éxito",
	"emailAddressNotRegistered": "La dirección de correo electrónico no está registrada\r\n\t\t",
	"emailAddressVerified": "La dirección de correo electrónico ya está verificada\r\n\t\t",
	"emailNotChanged": "Correo electrónico no cambiado",
	"emailOrPhoneNumber": "Correo electrónico o número de teléfono",
	"emailVerificationCompleted": "Verificación de correo electrónico completada.\r\n\t\t",
	"emailVerificationResent": "La verificación del correo electrónico ha sido reenviada",
	"emailVerificationSent": "Enlace de verificación de correo electrónico enviado\r\n\t\t",
	"enterCellphone": "Introduzca el teléfono",
	"enterFielddisplaylabel": "Escribir {FieldDisplayLabel}",
	"enterFkEfosStatus": "Introduzca el estatus Efos",
	"enterMail": "Introduzca el correo",
	"enterName": "Introduzca el Nombre",
	"name":"Nombre",
	"enterOtp": "Introduzca el OTP",
	"enterPassword": "Introduzca la contraseña",
	"enterPermission": "Introduzca el permiso",
	"enterRfc": "Introduzca el RFC",
	"enterRoleName": "Introduzca el nombre del rol",
	"enterSender": "Introduzca el remitente",
	"enterStatus": "Enter Status",
	"enterTheCode": "introduzca el código",
	"errorDeletingRecord": "Error al eliminar el registro por favor, asegúrese de que la salida de registro",
	"errorInsertingRecord": "Error al insertar el registro",
	"errorProcessingRequest": "¡Error al procesar la solicitud!",
	"errorRegisteringUser": "Error al registrar usuario",
	"errorSendingEmail": "Error al enviar un correo electrónico Por favor, póngase en contacto con el administrador del sistema para más información",
	"errorUploadingFile": "Error al cargar el archivo",
	"export": "Exportar",
	"exportCsv": "Exportar CSV",
	"exportExcel": "Exportar Excel",
	"exportPageFields": "Exportar campos de página",
	"exportWord": "Exportar palabra",
	"fileFormatNotSupported": "Formato de archivo no soportado",
	"fkEfosStatus": "Estatus de EFOS",
	"formIsInvalid": "El formulario no es válido",
	"helpAndFaq": "Ayuda y preguntas frecuentes",
	"hi": "Hola",
	"home": "Inicio",
	"id": "Id",
	"importData": "Datos de importacion",
	"invalidCaptchaCode": "Código Captcha inválido",
	"invalidEmailVerifyLink": "El enlace de verificación de correo electrónico no es válido",
	"invalidRequest": "Solicitud no válida",
	"language": "Idioma",
	"limit": "Límite",
	"loading": "Cargando...",
	"loadMore": "Carga más...",
	"login": "Iniciar sesión",
	"loginCompleted": "Inicio de sesión completado",
	"logout": "Cerrar sesión",
	"mail": "Correo",
	"mailDetails": "Detalles de correo",
	"mails": "Correos",
	"myAccount": "Mi cuenta",
	"newPassword": "Nueva contraseña",
	"noFileSelectedForUpload": "No se seleccionó ningún archivo para cargar",
	"noMoreContentToLoad": "No hay más contenido para cargar",
	"noRecordFound": "ningún registro fue encontrado",
	"noRecordInserted": "Ningún registro insertado",
	"noRecordUpdated": "No hay registro actualizado",
	"notAvailable": "No disponible",
	"number": "Número",
	"of": "de",
	"otpSentEmail": "OTP ha sido enviado a su correo electrónico",
	"otpSentSMS": "Se ha enviado OTP a su número de teléfono a través de SMS",
	"otpVerification": "Verificación OTP",
	"page": "Página",
	"password": "Contraseña",
	"passwordChangedMsg": "Tu contraseña ha sido restablecida",
	"passwordHint": "Sugerencias: no menos de 6 caracteres",
	"passwordReset": "Administrador de restablecimiento de contraseña",
	"passwordResetKeyFailure": "Error de clave de restablecimiento de contraseña\r\n\t\t",
	"passwordResetLinkMsg": "Se enviará un enlace a su correo electrónico que contiene la información que necesita para su contraseña",
	"passwordResetMsg": "Se ha enviado un mensaje a su correo electrónico. Siga amablemente el enlace para restablecer su contraseña",
	"passwordResetStepsMsg": "Por favor, puede intentar restablecer su contraseña siguiendo estos pasos",
	"pdfFile": "Archivo PDF",
	"permission": "Permiso",
	"errorLoadingFile": "Error al cargar el archivo",
	"receiptDate": "Fecha de recepción",
	"permissionDetails": "Detalles del permiso",
	"openFileInNewTab": "Abrir el archivo en una nueva pestaña",
	"fileNotSupported": "El archivo no es compatible con el navegador",
	"Fileviewer": "Visualizador de archivos",
	"All": "Todos",
	"Recivied": "Recibido",
	"Pending": "Pendiente",
	"Rejected": "Rechazado",
	"Approved": "Aprobado",
	"Paid": "Pagado",
	"Recivieds": "Recibidos",
	"Pendings": "Pendientes",
	"Rejecteds": "Rechazados",
	"Approveds": "Aprobados",
	"Paids": "Pagados",
	"permissionId": "Permiso Id",
	"permissions": "Permisos",
	"phoneNumber": "Número de teléfono",
	"photo": "Foto",
	"cellphone": "Telefono",
	"pleaseAChooseFile": "Por favor un archivo de elegir",
	"pleaseCompleteTheForm": "Por favor complete el formulario",
	"pleaseEnterText": "Por favor ingrese el texto",
	"print": "Impresión",
	"printPageSettings": "Imprimir configuración de página",
	"printPdf": "Imprimir | PDF",
	"privacyPolicy": "Política de privacidad",
	"promptAccountBlocked": "Tu cuenta ha sido bloqueada",
	"promptAccountCreated": "Tu cuenta ha sido creada",
	"promptAccountInReview": "Su cuenta está esperando revisión",
	"promptAccountNotActive": "Su cuenta no está activa. Póngase en contacto con el administrador del sistema para obtener más información.",
	"promptDeleteRecord": "¿Seguro que quieres borrar este registro?",
	"promptDeleteRecords": "¿Está seguro de que desea eliminar estos registros?\r\n\t\t",
	"promptEmailNotRegistered": "La dirección de correo electrónico no está registrada en el sistema",
	"promptForValidEmail": "Proporcione la dirección de correo electrónico válida que utilizó para registrarse",
	"promptPasswordConfirmFail": "La confirmación de su contraseña no es consistente",
	"promptPasswordExpired": "Tu contraseña ha expirado. Restablece tu contraseña para continuar.\r\n\t\t",
	"promptPasswordResetFailed": "Tu restablecimiento de contraseña no se completó\r\n\t\t",
	"provideNewPassword": "Proporcione una nueva contraseña",
	"recordAddedSuccessfully": "Grabar agregado exitosamente",
	"recordDeletedSuccessfully": "Grabar eliminado con éxito",
	"records": "Registros",
	"recordUpdatedSuccessfully": "Registro actualizado con éxito",
	"register": "Registro",
	"rememberMe": "Recuérdame",
	"removePageLinks": "Eliminar enlaces de página",
	"repseMenu":"REPSE",
	"repse": "Registro de Prestadoras de Servicios Especializados u Obras Especializadas (REPSE)",
	"repseDetails": "Detalles de REPSE",
	"resendEmail": "Reenviar email",
	"resetPassword": "Restablecer la contraseña",
	"rfc": "RFC",
	"roleDetails": "Detalles del rol",
	"roleId": "Rol Id",
	"roleName": "Nombre del rol",
	"rolePermissions": "Permisos del rol",
	"roles": "Roles",
	"rolesDetail": "Detalles de roles",
	"roleUsers": "roles de usuarios",
	"savePng": "Guardar PNG",
	"saving": "Guardando registro",
	"search": "Buscar",
	"selectAFileToImport": "Seleccione un archivo para importar",
	"selectAValue": "Seleccione un valor",
	"selectPaperSize": "Seleccione el tamaño de papel",
	"send": "Enviar",
	"sender": "Remitente",
	"shouldContain": "Debería contener",
	"showHeader": "Mostrar Encabezado",
	"sortBy": "Ordenar por",
	"status": "Estado",
	"fk_status": "Estado",
	"submit": "Entregar",
	"supplierDetails": "Detalles de proveedor",
	"suppliers": "Proveedores",
	"supplier": "Proveedor",
	"supportedFileTypes": "Tipos de archivos admitidos",
	"symbol": "Símbolo",
	"tabledisplaylabelDetails": "Ver",
	"termsAndConditions": "Términos y Condiciones",
	"theDashboard": "Tablero",
	"comment": "Comentarios",
	"unableToCompleteRequest": "No se puede completar la solicitud.",
	"update": "Actualizar",
	"updatedAt": "Actualizado en",
	"updateRecord": "Actualizar registro",
	"userDetails": "Detalles de usuario",
	"userLogin": "Inicio de sesión de usuario",
	"username": "Nombre de usuario",
	"usernameEmailPhoneNumber": "Nombre de usuario / Correo electrónico / Número de teléfono",
	"usernameOrEmail": "Nombre de usuario o correo electrónico",
	"usernameOrPasswordNotCorrect": "Nombre de usuario o contraseña no correctos",
	"usernameOrPhoneNumber": "Nombre de usuario o número de teléfono",
	"userRegistration": "Registro de usuario",
	"userRoleId": "Rol de usuario",
	"users": "Usuarios",
	"verify": "Verificar",
	"verifyEmailLinkMsg": "Verifique su dirección de correo electrónico siguiendo el enlace en su casilla de correo",
	"view": "Ver",
	"viewRecord": "Ver registro",
	"welcome": "Bienvenido",
	"xmlFile": "Archivo XML",
	"startsWith": "Comience con",
	"contains": "Contenga",
	"notContains": "No contenga",
	"endsWith": "Termine con",
	"equals": "Igual a",
	"notEquals": "Diferente a",
	"noFilter": "Sin filtro",
	"lt": "Menor que",
	"lte": "Menor o igual a",
	"gt": "Mayor que",
	"gte": "Mayor o igual a",
	"dateIs": "Fecha igual a",
	"dateIsNot": "Fecha diferente a",
	"dateBefore": "Fecha antes de",
	"dateAfter": "Fecha después de",
	"custom": "Personalizar",
	"clear": "Limpiar",
	"apply": "Aplicar",
	"matchAll": "Coincidir todo",
	"matchAny": "Coincidir con cualquiera",
	"addRule": "Agregar regla",
	"removeRule": "Eliminar regla",
	"accept": "Sí",
	"reject": "No",
	"choose": "Escoger",
	"upload": "Subir",
	"cancel": "Cancelar",
	"dayNames": [
		"Domingo",
		"Lunes",
		"Martes",
		"Miércoles",
		"Jueves",
		"Viernes",
		"Sábado"
	],
	"dayNamesShort": ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
	"dayNamesMin": ["D", "L", "M", "X", "J", "V", "S"],
	"monthNames": [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre"
	],
	"monthNamesShort": [
		"Ene",
		"Feb",
		"Mar",
		"Abr",
		"May",
		"Jun",
		"Jul",
		"Ago",
		"Sep",
		"Oct",
		"Nov",
		"Dic"
	],
	"today": "Hoy",
	"weekHeader": "Sem",
	"firstDayOfWeek": 1,
	"showMonthAfterYear": false,
	"dateFormat": "dd/mm/yy",
	"weak": "Débil",
	"medium": "Medio",
	"strong": "Fuerte",
	"passwordPrompt": "Escriba una contraseña",
	"emptyFilterMessage": "Sin opciones disponibles",
	"emptyMessage": "No se han encontrado resultados",
	"uploadedFiles": "Archivos subidos",
	"uploadFailed": "Fallo al subir",
	"maxFileLimit": "Limite de ${limit} archivos excedido!",
	"aria": {
		"trueLabel": "Verdadero",
		"falseLabel": "Falso",
		"nullLabel": "No seleccionado",
		"star": "1 estrella",
		"stars": "{star} estrellas",
		"selectAll": "Seleccionar todos",
		"unselectAll": "Deseleccionar todos",
		"close": "Cerrar",
		"previous": "Anterior",
		"next": "Siguiente",
		"navigation": "Navegación",
		"scrollTop": "Desplazarse arriba",
		"moveTop": "Mover arriba",
		"moveUp": "Subir",
		"moveDown": "Bajar",
		"moveBottom": "Desplazarse abajo",
		"moveToTarget": "Mover al objectivo",
		"moveToSource": "Mover al fuente",
		"moveAllToTarget": "Mover todo al objetivo",
		"moveAllToSource": "Mover todo al fuente",
		"pageLabel": "{page}",
		"firstPageLabel": "Primera Página",
		"lastPageLabel": "Última Página",
		"nextPageLabel": "Siguiente Página",
		"previousPageLabel": "Página Anterior",
		"rowsPerPageLabel": "Filas por página",
		"jumpToPageDropdownLabel": "Ir al menú desplegable de página",
		"jumpToPageInputLabel": "Ir a la entrada de página",
		"selectRow": "Seleccionar fila",
		"unselectRow": "Desmarcar fila",
		"expandRow": "Expandir Fila",
		"collapseRow": "Reducir Fila",
		"showFilterMenu": "Mostrar menú del filtro",
		"hideFilterMenu": "Ocultar menú del filtro",
		"filterOperator": "Operador de filtro",
		"filterConstraint": "Restricción de filtro",
		"editRow": "Editar fila",
		"saveEdit": "Guardar editado",
		"cancelEdit": "Cancelar editado",
		"listView": "Vista de lista",
		"gridView": "Vista de cuadrícula",
		"slide": "Deslizar",
		"slideNumber": "{slideNumber}",
		"zoomImage": "Ampliar imagen",
		"zoomIn": "Ampliar",
		"zoomOut": "Reducir",
		"rotateRight": "Girar derecha",
		"rotateLeft": "Girar izquierda"
	},
	"validations": {
		"required": "El valor es requerido.",
		"undefined": "El valor es requerido.",
		"email": "El valor no es una dirección de correo electrónico válida",
		"minLength": "Este campo debe tener al menos ${min} caracteres",
		"maxLength": "La longitud máxima permitida es ${max}",
		"minValue": "El valor mínimo permitido es ${min}",
		"maxValue": "El valor máximo permitido es ${max}",
		"numeric": "El valor debe ser numérico",
		"ipAddress": "El valor no es una dirección IP válida",
		"sameAs": "El valor debe ser igual al valor de ${otherName}"
	}

}